import { FormInput, Loader } from "@/components";
import { Button } from "@/components/ui";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui";
import { FormProvider } from "react-hook-form";
import { CONFIRM_PASSWORD, CURRENT_PASSWORD, NEW_PASSWORD } from "./consts";
import useLogin from "./useChangePassword";
import { images } from "@/assets";

const ChangePassword = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    onEyeIconClick,
    isPassword,
    Icon,
    isChangePasswordPending,
  } = useLogin();
  const { errors } = form.formState;

  return (
    <div className="flex md:flex-row w-full h-[100vh]">
      <div className="hidden md:flex flex-col justify-center items-center w-1/2 bg-blue-900 text-white p-8 relative">
        <div className="absolute inset-0 bg-black bg-opacity-30"></div>
        <img
          src={images.login_bg}
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="relative text-center z-10">
          <h1 className="text-[54px] font-bold">Welcome to Build Hive</h1>
          <p className="mt-2 text-lg">Please sign in to continue</p>
        </div>
      </div>
      <div className="w-full md:w-1/2 bg-gray-100 flex flex-col justify-center items-center p-8">
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <Card className="w-full lg:w-[400px]">
              <CardHeader className="my-[20px]">
                <CardTitle className="text-center font-[500] text-[24px]">
                  Change Password
                </CardTitle>
                <span className="text-[14px] text-g-400 text-center">
                  Update your password to ensure account security.
                </span>
              </CardHeader>
              <CardContent>
                <div className="grid grid-col-1 gap-5">
                  <div>
                    <label className="text-[14px] font-[400]">
                      Current Password
                    </label>
                    <FormInput
                      name={CURRENT_PASSWORD}
                      control={form.control}
                      placeholder="Please enter"
                      error={errors[CURRENT_PASSWORD]?.message}
                      isRequired={requiredFields.includes(CURRENT_PASSWORD)}
                      type={isPassword["current"] ? "password" : "text"}
                      endIcon={
                        <Icon
                          className="h-4 w-4"
                          onClick={onEyeIconClick("current")}
                        />
                      }
                    />
                  </div>
                  <div>
                    <label className="text-[14px] font-[400]">
                      New Password
                    </label>
                    <FormInput
                      name={NEW_PASSWORD}
                      control={form.control}
                      placeholder="Please enter"
                      error={errors[NEW_PASSWORD]?.message}
                      isRequired={requiredFields.includes(NEW_PASSWORD)}
                      type={isPassword["newPassword"] ? "password" : "text"}
                      endIcon={
                        <Icon
                          className="h-4 w-4"
                          onClick={onEyeIconClick("newPassword")}
                        />
                      }
                    />
                  </div>
                  <div>
                    <label className="text-[14px] font-[400]">
                      Confirm Password
                    </label>
                    <FormInput
                      name={CONFIRM_PASSWORD}
                      control={form.control}
                      placeholder="Please enter"
                      error={errors[CONFIRM_PASSWORD]?.message}
                      isRequired={requiredFields.includes(CONFIRM_PASSWORD)}
                      type={isPassword["confirm"] ? "password" : "text"}
                      endIcon={
                        <Icon
                          className="h-4 w-4"
                          onClick={onEyeIconClick("confirm")}
                        />
                      }
                    />
                  </div>
                </div>
                {/* <div className="flex flex-row items-start mt-4">
                  <FormCheckbox
                    name={TERMS_CONDITION}
                    control={form.control}
                    label=""
                    error={errors[TERMS_CONDITION]?.message}
                    isRequired={requiredFields.includes(TERMS_CONDITION)}
                  />
                  {/* <span className="px-[6px] bg-white text-[12px] text-g-400 flex items-center">
                    By clicking on submit, you have read and agree to the Build
                    Hive Terms & Conditions and Privacy Policy.
                  </span> 
                </div> */}
              </CardContent>
              <CardFooter>
                <Button
                  type="submit"
                  className="w-full"
                  disabled={isChangePasswordPending}
                >
                  {isChangePasswordPending ? (
                    <Loader variant="secondary" />
                  ) : (
                    ""
                  )}{" "}
                  Change Password
                </Button>
              </CardFooter>
            </Card>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default ChangePassword;
